import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.css']
})
export class DialogBoxComponent implements OnInit {
  @Input() dialogEntry;
  @Output() onconfirm: any = new EventEmitter<any>();
  public code: any;
  public submitted: boolean;
  constructor() { }

  ngOnInit() {
  }

  onClick() {
    if (this.dialogEntry.getCode) {
      this.submitted = true;
      localStorage.setItem("useraccesstoken", this.code);
    }
    if (this.dialogEntry.getEmail) {
      this.submitted = true;
      if (this.isEmailValid)
        this.onconfirm.emit(this.code);
    } else {
      this.onconfirm.emit(true);
    }

  }

  onClose() {
    this.onconfirm.emit(false);
  }

  public isEmailValid: boolean;
  ValidateEmail(mail) {
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
      this.isEmailValid = true
    }
    else this.isEmailValid = false;

  }
}
